import { RichText } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo, useMemo, useState } from 'react';
import reactStringReplace from 'react-string-replace';
import VisibilitySensor from 'react-visibility-sensor';
import { Metric } from './Metric';
import useStyles from './Stat.styles';

const Stat = ({ value, description, theme }: any) => {
  const classes = useStyles({});
  const [visible, setVisible] = useState(false);

  const handleVisibilitySensorChange = (isVisible: boolean) => {
    if (isVisible) {
      setVisible(true);
    }
  };

  const metric = useMemo(
    () =>
      reactStringReplace(value, /(\d+)/g, (match, i) => (
        <Metric key={i} value={visible ? +match : 0} />
      )),
    [value, visible],
  );

  const rootClasses = clsx(classes.root, `${theme}-theme`);
  return (
    <div className={rootClasses}>
      <VisibilitySensor delayedCall onChange={handleVisibilitySensorChange}>
        <MuiTypography variant="h3" component="h5" className={classes.metric}>
          {metric}
        </MuiTypography>
      </VisibilitySensor>
      <RichText className={classes.description} content={description} theme={theme} />
    </div>
  );
};

export default memo(Stat);
